var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPencilpencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7352 27.8896H6.14941C5.8842 27.8896 5.62984 27.7842 5.44231 27.5967C5.25477 27.4092 5.14941 27.1548 5.14941 26.8896V21.3038C5.14941 21.1725 5.17528 21.0424 5.22553 20.9211C5.27579 20.7998 5.34945 20.6896 5.44231 20.5967L20.4423 5.59669C20.6298 5.40916 20.8842 5.3038 21.1494 5.3038C21.4146 5.3038 21.669 5.40916 21.8565 5.59669L27.4423 11.1825C27.6298 11.37 27.7352 11.6244 27.7352 11.8896C27.7352 12.1548 27.6298 12.4092 27.4423 12.5967L12.4423 27.5967C12.3494 27.6896 12.2392 27.7632 12.1179 27.8135C11.9966 27.8637 11.8665 27.8896 11.7352 27.8896Z",
    stroke: "#677791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1494 8.88959L24.1494 15.8896",
    stroke: "#677791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0854 27.8257L5.21289 20.9532",
    stroke: "#677791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilpencil);
export default __webpack_public_path__ + "static/media/Pencilpencil.03caa381e8af04521c85b3d3c3ef8f75.svg";
export { ForwardRef as ReactComponent };